import styled from '@emotion/styled'
import { css } from '@emotion/react'

const baseStyles =
  ({ theme }) => css`
    position: relative;

    width: 100%;
    height:  91px;

    display: flex;
    align-items: center;

    margin-top: -${theme.spacings.mega};

    background-image: url(${window &&
      window.env.assetHost.replace(
        /\/$/g,
        ''
      )}/assets/images/lmcv/header/background-mobile.svg);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;

    overflow: hidden;

    ${theme.media.kilo} {
      height: 107px;
    }

    ${theme.media.mega} {
      height: 160px;

      margin-top: -${theme.spacings.tera};

      background-image: url(${window &&
        window.env.assetHost.replace(
          /\/$/g,
          ''
        )}/assets/images/lmcv/header/background-desktop.svg);
      background-position: center center;
    }
  `

export const HeaderElement = styled('div')(baseStyles)

const photoStyles =
  ({ theme, load }) => css`
    position: relative;

    width: 70px;
    height: 70px;

    padding: 5px;

    margin-left: 30px;
    margin-right: 95px;

    border: 1px solid ${load ? theme.colors.n400 : theme.colors.v600};
    border-radius: 50%;

    overflow: hidden;

    ${theme.media.tera} {
      width: 90px;
      height: 90px;
    }

    ${theme.media.mega} {
      width: 100px;
      height: 100px;

      margin-left: 60px;
    }
  `

export const Photo = styled('div')(photoStyles)

const photoImageStyles =
  ({ theme, avatar }) => css`
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 24px;
    color: ${theme.colors.n700};

    border-radius: ${theme.borderRadius.circle};

    background-color: ${theme.colors.n400};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    ${avatar ? `background-image: url(${avatar});` : ''}

    box-shadow: 0 2px 6px rgba(84, 60, 158, 0.426437);

    ${theme.media.mega} {
      font-size: 32px;
    }
  `

export const PhotoImage = styled('div')(photoImageStyles)

const welcomeStyles =
  ({ theme }) => css`
  display: none;

  ${theme.media.mega} {
    display: block;
  }
`

export const Welcome = styled('div')(welcomeStyles)

const textWelcomeStyles =
  ({ theme }) => css`
    display: block;

    margin-bottom: 10px;

    color: ${theme.colors.v300};

    font-size: 14px;

    line-height: 17px;
    text-align: right;
  `

export const TextWelcome = styled('span')(textWelcomeStyles)

export const textSvgStyles =
  ({ theme }) => css`
    display: block;

    width: 118px;

    path {
      fill: ${theme.colors.white};
    }
  `

export const TextSvg = styled('svg')(textSvgStyles)

const ticketStyles =
  ({ theme }) => css`
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-top: -2px;
    margin-left: -30px;

    text-align: center;
    white-space: pre-wrap;

    ${theme.media.kilo} {
      margin-left: -10px;
    }

    ${theme.media.mega} {
      width: 175px;
      height: 60px;

      margin-top: 0;
      margin-left: ${theme.spacings.peta};

      border: 1px solid #B14AE7;
      border-radius: 24px;

      &:before,
      &:after {
        content: '';

        position: absolute;
        top: 50%;

        width: 22px;
        height: 22px;

        background: #7e10b2;

        transform: translateY(-50%);
      }

      &:before {
        left: -11px;

        border: 1px solid #B14AE7;
        border-radius: 50%;
      }

      &:after {
        left: -23px;
      }
    }

    ${theme.media.giga} {
      width: 245px;
      height: 75px;
    }
  `

export const Ticket = styled('div')(ticketStyles)

const ticketValueStyles =
  ({ theme }) => css`
    display: inline-block;
    color: ${theme.colors.white};

    font-size: 24px;
    font-weight: ${theme.font.weight.semibold};

    line-height: 32px;

    ${theme.media.mega} {
      font-size: 24px;
      line-height: 32px;
    }

    ${theme.media.giga} {
      font-size: 36px;
      line-height: 43px;
    }
  `

export const TicketValue = styled('span')(ticketValueStyles)

const ticketTextStyles =
  ({ theme }) => css`
    display: inline-block;

    color: ${theme.colors.white};

    font-size: 16px;

    ${theme.media.mega} {
      font-size: 18px;
    }
  `

export const TicketText = styled('span')(ticketTextStyles)

const ticketHaveTextStyles =
  ({ theme }) => css`
    display: block;
    color: ${theme.colors.f300};

    font-size: 12px;

    line-height: 17px;

    ${theme.media.mega} {
      display: none;
    }
  `

export const TicketHaveText = styled('span')(ticketHaveTextStyles)
